//首页接口
import axios from '../common/js/axios'
import { host } from '../common/js/config'

/*示例*/
export function getHomeData(data) {
	const url = `${host}/app/valueadded/courseinfo`
	return axios({
		url: url,
		params: data
	})
}

const BANNER = host+'/app/index/banner'

const COLLEGEPROTYPECOURSE = host+'/app/college/courseList'

const COLLEGEPROTYPE = host+'/app/querySubjectByCollegeProType' //课程选择 分类

const CHILDWEBSITEINFO = host+'/app/collegeInfo'

const COLLEGETYPE = host+'/app/collegeProTypeList'

const GETGRADUATION = host+'/app/valueadded/getUserCertificateInfo'

// 课程列表
const COURSELIST = host+'/app/college/queryCourseList'// '/app/college/courseList'

// 多章节课程详情页
const COURSESDETAIL = host+'/app/valueadded/courseinfo'
// 章节
const COURSECHAPTER = host+'/app/valueadded/coursechapter'
// 课程分类
const COURSETYPE = host+'/app/college/websiteCourseList'
// 热门课程
const HOTCOURSELIST = host+'/app/college/queryHotCourseList'
// 评论列表
const COMMENT = host+'/app/course/comment/list'
// 我的课程
const MYLESIION = host+'/app/uc/course'
// 收藏
const COLLECT = host+'/app/course/addfavorites'
// 取消收藏
const DEL_COLLECT = host+'/app/collection/cleanFavorites'
// 评论点赞
const COMMENTGOOD = host+'/app/course/commentpraise'
// 首页接口
const HOMELIST = host+'/app/college/queryCollegeProperty'
// 获取笔记接口
const NOTE = host+'/app/course/note/list'
// 获取问答接口
const QUESTION = host+'/app/course/question/list'
// 视频播放时间
const VIDEOTIME = host+'/app/valueadded/addloglearn'
// 购买免费课程
const BUYFREE = host+'/app/order/buyFreeCourse'
// 添加积分
const INTEGRAL = host+'/app/userCollegeIntegral/add'

//获取outer视频
const OUTERVIDEO = host+'/app/kpoint/outerUrl'

// 获取首页信息
export function getHomeList(data) {
	return axios({
		url: HOMELIST,
		data: data,
		method: "POST"
	})
}

export function getHomeBanner(data) {
	return axios({
		url: BANNER,
		params: data
	})
}

// 评论点赞
export function getCommentGood(data) {
	return axios({
		url: COMMENTGOOD,
		params: data,
		method: "GET"
	})
}

// 取消收藏

export function DelCollect(data) {
	return axios({
		url: DEL_COLLECT,
		params: data,
		method: "GET"
	})
}

// 收藏
export function getCollect(data) {
	return axios({
		url: COLLECT,
		params: data,
		method: "GET"
	})
}

//笔记
export function getNote(data) {
	return axios({
		url: NOTE,
		params: data,
		method: "GET"
	})
}

//问答
export function getQuestion(data) {
	return axios({
		url: QUESTION,
		params: data,
		method: "GET"
	})
}
//视频播放时间
export function getVideoTime(data) {
	return axios({
		url: VIDEOTIME,
		params: data,
		method: "GET"
	})
}
//购买免费课程
export function getBuyfree(data) {
	return axios({
		url: BUYFREE,
		params: data,
		method: "GET"
	})
}

// 获取热门课程
export function getHotList(data) {
	return axios({
		url: HOTCOURSELIST,
		params: data,
		method: "GET"
	})
}

// 获取课程大分类
export function getCollegeType(data) {
	return axios({
		url: COLLEGETYPE,
		params: data,
		method: "GET"
	})
}
// 获取课程数据
export function getCourseList(data) {
	return axios({
		url: COURSELIST,
		params: data,
		method: "GET"
	})
}

//课程详情
export function getCoursesDetail(data) {
	return axios({
		url: COURSESDETAIL,
		params: data,
		method: "GET"
	})
}
// 章节
export function getCourseChapter(data) {
	return axios({
		url: COURSECHAPTER,
		params: data,
		method: "GET"
	})
}
// 课程分类
export function getCourseType(data) {
	return axios({
		url: COURSETYPE,
		params: data,
		method: "GET"
	})
}

//课程选择分类 classify
export function getCollegeProType(data) {
	return axios({
		url: COLLEGEPROTYPE,
		params: data
	})
}
//课程选择分类下 课程 classify
export function getCollegeProTypeCourse(data) {
	return axios({
		url: COLLEGEPROTYPECOURSE,
		params: data
	})
}

// 评论列表
export function getComment(data) {
	return axios({
		url: COMMENT,
		params: data,
		method: "GET"
	})
}
// 我的课程列表
export function getMyLession(data) {
	return axios({
		url: MYLESIION,
		params: data,
		method: "GET"
	})
}

//获取子站点信息
export function getChildInfo(data) {
	return axios({
		url: CHILDWEBSITEINFO,
		params: data
	})
}

//结业证书
export function getGraduation(data) {
	return axios({
		url: GETGRADUATION,
		params: data
	})
}

// OUTER视频
export function getOuterVideo(data) {
	return axios({
		url: OUTERVIDEO,
		params: data,
		method: "GET"
	})
}

// 添加积分
export function addIntegralOper(data) {
	return axios({
		url: INTEGRAL,
		params: data,
		method: "GET"
	})
}

// 提交个人信息
export function postPersonal(data) {
	return axios({
		url: host+'/app/user/update/info',
		params: data,
		method: "GET"
	})
}

export function getRule2(data) {
	return axios({
		url: host+'/app/userCollegeIntegral/ruleList',
		params: data,
		method: "GET"
	})
}


//vip 会员
export function getUserRecord(data) {
	return axios({
		url: host+'/app/member/userRecord',
		params: data
	})
}
//vip会员课程列表
export function getMemberCourseList(data) {
	return axios({
		url: host+'/app/member/memberCourseList',
		params: data
	})
}

//vip会员类型列表接口
export function getTypeList(data) {
	return axios({
		url: host+'/app/member/typeList',
		params: data
	})
}

//vip学习记录汇总数据接口
export function memberCourseStudyTotal(data) {
	return axios({
		url: host+'/app/member/memberCourseStudyTotal',
		params: data
	})
}

//vip学习记录分页数据接口
export function memberCourseStudyList(data) {
	return axios({
		url: host+'/app/member/memberCourseStudyList',
		params: data
	})
}


// WEBPACK FOOTER //
// ./src/api/home.js